module.exports = __webpack_public_path__ + "static/media/define_flower.ac9346b4.png";